// extracted by mini-css-extract-plugin
export var aboutBlock = "switcherTextBlock-module--aboutBlock--TPEq0";
export var aboutStickerHalvau = "switcherTextBlock-module--aboutStickerHalvau--432Ae";
export var aboutText = "switcherTextBlock-module--aboutText--22EzG";
export var aboutTitle = "switcherTextBlock-module--aboutTitle--bDPqW";
export var active = "switcherTextBlock-module--active--r4JHc";
export var additionalText = "switcherTextBlock-module--additionalText--jX52b";
export var answer = "switcherTextBlock-module--answer--CHs4r";
export var base = "switcherTextBlock-module--base--qYQLE";
export var benefitTitle = "switcherTextBlock-module--benefitTitle--ybPk7";
export var benefitsList = "switcherTextBlock-module--benefitsList--ImqqS";
export var biggerTextAtPoint = "switcherTextBlock-module--biggerTextAtPoint--MOLAn";
export var bottomTextContent = "switcherTextBlock-module--bottomTextContent--XWoJc";
export var btn = "switcherTextBlock-module--btn--V-K+E";
export var cashbackTable = "switcherTextBlock-module--cashbackTable--NEhMy";
export var coffeTitle = "switcherTextBlock-module--coffeTitle--J+IZJ";
export var creditCards = "switcherTextBlock-module--creditCards--aDy9v";
export var displayNone = "switcherTextBlock-module--displayNone--5c+3p";
export var documentLink = "switcherTextBlock-module--documentLink--RRpfZ";
export var documentPkwCreditCards = "switcherTextBlock-module--documentPkwCreditCards--vAP+m";
export var documentPlaneta = "switcherTextBlock-module--documentPlaneta--9xLhS";
export var documentsBlock = "switcherTextBlock-module--documentsBlock--dDhKS";
export var documentsBlockBorder = "switcherTextBlock-module--documentsBlockBorder--TPObr";
export var documentsLink = "switcherTextBlock-module--documentsLink--wxttn";
export var documentsLinkCoffee = "switcherTextBlock-module--documentsLinkCoffee--+mxZx";
export var documentsSize = "switcherTextBlock-module--documentsSize--6CHTr";
export var fw_bold = "switcherTextBlock-module--fw_bold--bnoMu";
export var headerCell = "switcherTextBlock-module--headerCell--HPGK+";
export var htmlBlock = "switcherTextBlock-module--htmlBlock--CxKJI";
export var info_title = "switcherTextBlock-module--info_title--rQtsQ";
export var info_title_container = "switcherTextBlock-module--info_title_container--GuFsD";
export var instruction = "switcherTextBlock-module--instruction--Td+rd";
export var link_text_default = "switcherTextBlock-module--link_text_default--SYSL4";
export var link_text_small = "switcherTextBlock-module--link_text_small--kt4kz";
export var listAnswer = "switcherTextBlock-module--listAnswer--xN5+e";
export var listAnswerPadding = "switcherTextBlock-module--listAnswerPadding--b+02e";
export var listQuestion = "switcherTextBlock-module--listQuestion--WmThM";
export var listStickerMode = "switcherTextBlock-module--listStickerMode--y-fTH";
export var listStyleDisc = "switcherTextBlock-module--listStyleDisc--BDn1w";
export var list_items = "switcherTextBlock-module--list_items--DuSlu";
export var modeSticker = "switcherTextBlock-module--modeSticker--DUyga";
export var planetacard = "switcherTextBlock-module--planetacard--j6EKc";
export var pointRedHalva = "switcherTextBlock-module--pointRedHalva--hRt51";
export var pravdaCoffee = "switcherTextBlock-module--pravdaCoffee--HJs0f";
export var red = "switcherTextBlock-module--red--njzEJ";
export var section = "switcherTextBlock-module--section--dcuVt";
export var sticker = "switcherTextBlock-module--sticker--IB-sd";
export var subtitle = "switcherTextBlock-module--subtitle--W0oej";
export var supIndex = "switcherTextBlock-module--supIndex--IAX41";
export var switcherTitle = "switcherTextBlock-module--switcherTitle--KqwgR";
export var table = "switcherTextBlock-module--table--IN7rs";
export var table__bold = "switcherTextBlock-module--table__bold--4SvMe";
export var table__cell = "switcherTextBlock-module--table__cell--t4E+7";
export var wrapperListAnswer = "switcherTextBlock-module--wrapperListAnswer--2Rf3Y";